<template>
  <div>
    <div class="banner" :style="bannerStyle">
      <div class="banner-box">
        <div>
          <h2 style="color:#fff">
            {{ pageTitle }}
          </h2>
          <p>
            {{ pageSubtitle }}
          </p>
        </div>
      </div>
    </div>
    <div class="container">
      <section class="required-info" v-if="requiredInfo.description">
        <h3>必修課程注意事項</h3>
        <p>{{ requiredInfo.description }}</p>
        <!-- <div class="required-info-meta">
          <span>建議必修學習總時數：{{ requiredInfoHours }}</span>
          <span>建議完成日期：{{ requiredInfoDueDate }}</span>
        </div> -->
      </section>
      <div class="row my-3">
        <!-- <div class="col-md-3">
          <div class="row pr-4">
            <div class="col-12">
              <div class="d-flex my-3">
                <h3 class="title pr-3">{{ $t('Course_Overview.cefr_level') }}</h3>
                <div class="line"></div>
              </div>
              <div class="d-flex flex-md-column">
                <div class="form-group form-check">
                  <input v-model="cefr" type="checkbox" value="A1" class="form-check-input">
                  <label class="form-check-label">A1<span class="rwd-hide">{{ $t('Course_Overview.A1') }}</span></label>
                </div>
                <div class="form-group form-check">
                  <input v-model="cefr" type="checkbox" value="A2" class="form-check-input">
                  <label class="form-check-label">A2<span class="rwd-hide">{{ $t('Course_Overview.A2') }}</span></label>
                </div>
                <div class="form-group form-check">
                  <input v-model="cefr" type="checkbox"  value="B1" class="form-check-input">
                  <label class="form-check-label">B1<span class="rwd-hide">{{ $t('Course_Overview.B1') }}</span></label>
                </div>
                <div class="form-group form-check">
                  <input v-model="cefr" type="checkbox" value="B2" class="form-check-input">
                  <label class="form-check-label">B2<span class="rwd-hide">{{ $t('Course_Overview.B2') }}</span></label>
                </div>
                <div class="form-group form-check">
                  <input v-model="cefr" type="checkbox" value="C1" class="form-check-input">
                  <label class="form-check-label">C1<span class="rwd-hide">{{ $t('Course_Overview.C1') }}</span></label>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div div class="d-flex my-3">
                <h3 class="title pr-3">{{ $t('Course_Overview.unit_test') }}</h3>
                <div class="line"></div>
              </div>
              <div>
                <div class="form-group form-check">
                  <input type="checkbox" v-model="pass" value="1" class="form-check-input">
                  <label class="form-check-label">{{ $t('Course_Overview.passed') }}</label>
                </div>
                <div class="form-group form-check">
                  <input type="checkbox" v-model="pass" value="-1"  class="form-check-input">
                  <label class="form-check-label">{{ $t('Course_Overview.unpassed') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-md-1200">
          <div class="row d-flex justify-content-between">
            <div class="d-flex rwd-hide align-items-center">
              <div class="mx-3 d-flex">
                <img src="../assets/image/pic/icon_class_subject_commentary.png" alt="">
                <div class="my-auto" style="white-space:nowrap;">{{ $t('Course.Description_video') }}</div>
              </div>
              <div class="mr-3 d-flex">
                <img src="../assets/image/pic/icon_class_subject_teaching.png" alt="">
                <div class="my-auto" style="white-space:nowrap;">{{ $t('Course.Interactive_learning') }}</div>
              </div>
              <div class="mr-3 d-flex">
                <img src="../assets/image/pic/icon_class_subject_text.png" alt="">
                <div class="my-auto" style="white-space:nowrap;">{{ $t('Course.Unit_test') }}</div>
              </div>
              <div class="mr-3 d-flex">
                <img style="max-height:25px" src="../assets/image/icon&btn/icon_other/icon_read_G.png" alt="">
                <div class="my-auto">已瀏覽</div>
              </div>
              <div class="mr-3 d-flex">
                <img style="max-height:25px" src="../assets/image/pic/icon_class_video_complete.png" alt="">
                <div class="my-auto">已通過</div>
              </div>
            </div>
          </div>
          <div class="row mt-2" v-if="lessonData.length>0">
            <div v-for="item in lessonData" :key="item.id" class="col-lg-3 col-md-6 col-sm-12 card-box" >
              <div v-if="item.type === 'digital'" class="card my-2 pointer" @click="goCoursePage(item.id)">
                <div class="picture image-box pointer">
                  <img class="tag" v-if="!item.is_favorite" src="../assets/image/pic/btn_tag_off.png" alt="" @click.stop="addCollections(item)">
                  <img class="tag" v-else src="../assets/image/pic/btn_tag_on.png" alt="" @click.stop="removeCollections(item)">
                  <span class="label">{{item.is_new?'New':''}}</span>
                  <img :src="item.cover" class="card-img-top cover">
                </div>
                <div class="card-body" style="background:	#F5F5F5">
                  <div class="card-title" style="height:110px">
                    <div class="content">
                      <h5>{{item.name}}</h5>
                    </div>
                    <div class="content">
                      <p>{{item.name_en}}</p>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-stretch" style="cursor: default;">
                    <ul class="my-auto wrapper">
                      <li class="icon">
                        <span class="tooltip">CEFR分級</span>
                        <span class="badge badge-danger">{{item.cefr}}</span>
                      </li>
                      <li class="icon">
                        <span class="tooltip">{{ $t('Course.Description_video') }}</span>
                        <img v-if="item.has_detail_video" src="../assets/image/pic/icon_class_subject_commentary.png" alt="">
                      </li>
                      <li class="icon">
                        <span class="tooltip">{{ $t('Course.Interactive_learning') }}</span>
                        <img v-if="item.has_live_course" src="../assets/image/pic/icon_class_subject_teaching.png" alt="">
                      </li>
                      <li class="icon">
                        <span class="tooltip">{{ $t('Course.Unit_test') }}</span>
                        <img v-if="item.has_practice" src="../assets/image/pic/icon_class_subject_text.png" alt="">
                      </li>
                    </ul>
                    <div class="my-auto">
                      <ul class="my-auto wrapper">
                        <li class="icon" v-if="item.is_read">
                          <span class="tooltip">{{ $t('Course.is_viewed') }}</span>
                          <img  class="my-auto mx-1" style="width:25px; height:25px" src="../assets/image/icon&btn/icon_other/icon_read_G.png" alt="">
                        </li>
                        <li class="icon" v-if="item.is_pass">
                          <span class="tooltip">{{ $t('Course.is_passed') }}</span>
                          <img  class="my-auto mx-1" style="width:25px; height:25px" src="../assets/image/pic/icon_class_video_complete.png" alt="">
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mx-auto">
              <pagination v-if="pageCount>1 && lessonData.length>0" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-12 default-info">
              <h5>
                目前找到0筆資料，請改以其他關鍵字或篩選功能搜尋課程。
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import Pagination from '@/components/Pagination.vue'
import api from '../store/api'
import obligatoryBanner from '../assets/image/home/banner_bg_obligatory.jpg'

export default {
  name: 'Required',
  components: {
    Pagination
  },
  computed: {
    routeName () {
      return 'Required'
    },
    pageTitle () {
      return this.requiredInfo.title || '必修課程專區'
    },
    pageSubtitle () {
      return this.requiredInfo.title_en || 'Required Courses'
    },
    bannerStyle () {
      return {
        backgroundImage: `url(${obligatoryBanner})`
      }
    },
    requiredInfoHours () {
      const requiredCourse = this.targetInfo.required_course
      if (!requiredCourse || !requiredCourse.rule || requiredCourse.rule === '00:00:00') {
        return ''
      }
      return requiredCourse.rule
    },
    requiredInfoDueDate () {
      if (!this.userInfo || !this.userInfo.group_end_at) {
        return ''
      }
      return String(this.userInfo.group_end_at).split(' ')[0].split('T')[0]
    },
    ...mapGetters([
      'authInfo',
      'userInfo'
    ])
  },
  watch: {
    $route () {
      this.routeSyncing = true
      this.cefr = this.$route.query.cefr ? this.$route.query.cefr.split(',') : []
      this.pass = this.$route.query.pass ? this.$route.query.pass.split(',') : []
      this.pageIndex = this.$route.query.page
      this.getLessonInfo()
      this.$nextTick(() => {
        this.routeSyncing = false
      })
    },
    cefr (val ) {
      if (this.routeSyncing) {
        return
      }
      this.pageIndex = 1
      this.$router.push({
        name: this.routeName,
        query:{
          cefr: val.join(',') || null,
          pass: this.$route.query.pass,
          page: 1
        }
      })
    },
    pass (val) {
      if (this.routeSyncing) {
        return
      }
      this.pageIndex = 1
      this.$router.push({
        name: this.routeName,
        query: {
          cefr: this.$route.query.cefr,
          pass: val.join(',') || null,
          page: 1
        }
      })
    }
  },
  data () {
    return {
      routeSyncing: false,
      cefr: this.$route.query.cefr ? this.$route.query.cefr.split(',') : [],
      pass: this.$route.query.pass ? this.$route.query.pass.split(',') : [],
      lessonData: [],
      pageIndex: this.$route.query.page,
      pageCount: 0,
      pageSize: 12,
      requiredInfo: {},
      targetInfo: {}
    }
  },
  mounted () {
    this.scrollTop()
    this.getLessonInfo()
    this.getTargetInfo()
  },
  methods: {
    ...mapActions({
      getUser: 'getUser'
    }),
    async getLessonInfo () {
      const params = {
        cefr: this.cefr.join(','),
        orderBy : 'desc',
        pass: this.pass.join(','),
        page: this.pageIndex,
        pageSize: this.pageSize
      }
      const { data } = await api.get('/contents/courses/required', { params })
      const result = data.data && !Array.isArray(data.data) ? data.data : data
      const collection = Array.isArray(data.data)
        ? data.data
        : (result.data || result.required_courses || result.courses || result.items || [])

      this.lessonData = Array.isArray(collection) ? collection : (collection.data || [])
      this.pageIndex = result.pageIndex || data.pageIndex
      this.pageCount = result.pageCount || data.pageCount
      this.requiredInfo = {
        ...this.requiredInfo,
        title: result.title || data.title,
        title_en: result.title_en || data.title_en,
        description: result.description || data.description || this.requiredInfo.description
      }
    },
    async getTargetInfo () {
      const { data } = await api.get('/me/records')
      this.targetInfo = data.data || {}
    },
    toPage (toPage) {
      this.$router.push({
        name: this.routeName,
        query:{
          pass: this.$route.query.pass,
          cefr: this.$route.query.cefr,
          page: toPage
        }
      })
    },
    async addCollections (el) {
      // el.banner = this.info.banner
      await this.getLessonId(el.id).then((val) => {
        try {
          const json = {
            banner: val.package_course.banner,
            view_id: val.sections[0].data.view_id||val.sections[0].id
          }
          const fileData = new window.FormData()
          fileData.append('json', JSON.stringify(json))
          fileData.append('view_id', val.sections[0].data.view_id||val.sections[0].id)
          api.post(`collections/course/${el.id}`, fileData).then((res)=> {
            if (res.status === 200) {
              this.getLessonInfo()
            }
          })
        } catch (error) {
          console.error(error.response.data)
        }
      })
    },
    async removeCollections (el) {
      await this.getLessonId(el.id).then((val) => {
        try {
          api.delete(`collections/course/${el.id}`).then((res)=> {
            if (res.status === 200) {
              this.getLessonInfo()
            }
          })
        } catch (error) {
          console.error(error.response.data)
        }
      })
    },
    async getLessonId (id) {
      const { data } = await api.get(`/contents/courses/${id}`)
      if (data.status === 'Success') {
        return data.data
      }
    },
    async goCoursePage (id) {
      await this.getLessonId(id).then((val) => {
        this.$router.push({ name: 'CourseLesson', params: { lesson: val.id, courseId: val.sections[0].data.view_id||val.sections[0].id } })
      })
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../assets/styles/color.scss";
  @import "../assets/styles/custom.scss";
  .container {
    text-align: left;
  }
  .required-info {
    margin: 28px auto 24px;
    padding: 28px 30px;
    background: #fff;
    border: 1px solid #d8e8f0;
    border-radius: 4px;
    box-shadow: 0 0 6px rgba(21, 47, 68, .14);
    h3 {
      margin-bottom: 16px;
      color: #183d58;
      font-size: 1rem;
      font-weight: 800;
    }
    p {
      margin-bottom: 22px;
      color: #000;
      font-size: .95rem;
      line-height: 1.6;
    }
  }
  .required-info-meta {
    display: flex;
    justify-content: flex-end;
    gap: 48px;
    color: #d8753d;
    font-size: .95rem;
  }
  .title {
    font-size: 1.5rem;
    font-weight: 800;
    color: $main-color;
    background-color: $white-color;
    z-index: 10;
  }
  .line {
    // width: 100%;
    width: 98%;
    position: absolute;
    // left: 100%;
    top: 32px;
    border-top: black 1px solid;
  }
  .banner {
    height: 250px;
    background-image: url('../assets/image/home/banner_bg_obligatory.jpg');
    background-repeat: no-repeat;
    // background-attachment: fixed;
    background-position: center;
    background-size: cover;
    .banner-box {
      padding: 60px 0 10px 0;
      h2 {
        font-size: 3rem;
        font-weight: 800;
        margin-bottom: 1rem;
      }
      p {
        color: rgb(47, 161, 255);
        font-weight: 600;
        margin: 0;
        font-size: 1.25rem;
      }
    }
  }
  .form-check {
    white-space: nowrap;
  }
  .picture {
    position:relative;
    min-height: 200px;
    max-height: 200px;
    overflow: hidden;
    background-color: #000;
    .cover {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 130%;
      height: 130%;
      object-fit: contain;
      transition:all 0.2s ease;
    }
    .tag {
      width: 20px;
      position: absolute;
      top: 5%;
      left: 5%;
      z-index: 50;
    }
    .label {
      background-color: red;
      padding: 0 30px 0 60px ;
      color: rgb(255, 255, 255);
      font-weight: bolder;
      font-size: 1rem;
      transform: rotate(35deg);
      position: absolute;
      top: 0%;
      right: -8%;
      z-index: 50;
    }
  }
  .picture .cover:hover {
    transform: scale(1.05)  translate(-50%,-50%);
    filter:opacity(.8);
  }
  .course-info {
    text-align: left;
    // padding: 20px 50px;
  }
  .circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: $gray-color;
    div {
      width: 50px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      color: white;
    }
  }
  .card-title {
    border-bottom: 1px solid #bbb;
    text-align: left;
    .content {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    h5 {
      font-size: 1.2rem;
      font-weight: bolder;
    }
    p {
      font-size: .8rem;
    }
  }
  .default-info {
    height: 50vh;
    h5 {
      width: 80%;
      color: rgb(122, 122, 122);
      font-size: 1.5rem;
      @include center();
    }
  }
  .wrapper {
    padding: 0px;
    display: inline-flex;
    list-style: none;
  }

  .wrapper .icon {
    position: relative;
    //background: #ffffff;
    //border-radius: 50%;
    //padding: 15px;
    //margin: 10px;
    //width: 50px;
    //height: 50px;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    //box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
    //cursor: pointer;
    transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .wrapper .tooltip {
    position: absolute;
    top: 0;
    font-size: 14px;
    white-space:nowrap;
    background: #000000;
    color: #ffffff;
    padding: 5px 8px;
    border-radius: 5px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .wrapper .tooltip::before {
    position: absolute;
    content: "";
    height: 8px;
    width: 8px;
    background: #000000;
    bottom: -3px;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .wrapper .icon:hover .tooltip {
    top: -45px;
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
  .wrapper .icon:hover span,
  .wrapper .icon:hover .tooltip {
    text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.1);
  }
  @media all and (max-width: 767px) {
    .required-info {
      margin: 20px 0 18px;
      padding: 20px;
    }
    .required-info-meta {
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
    }
    .rwd-hide {
      display: none !important;
    }
    .form-group {
      margin: auto;
    }
  }
</style>
